import { useMemo } from "react";
import { GridColDef } from "../../Unknown/DataGrid";
import useColumnOptions from "./columns/useColumnOptions";
import getColumnStatus from "./columns/getColumnStatus";
import getColumnName from "./columns/getColumnName";
import getColumnAlert from "./columns/getColumnAlert";
import { AppointmentReport } from "./types";
import useTranslations from "./useTranslations";

const useColumns = (params: {
  hiddenHeaderSeparatorRoot: string;
  onUnexpectedFindingsClick: (id: string) => void;
  onConfirmReceiptClick: (id: string) => void;
  onViewClick: (id: string) => void;
}): GridColDef<AppointmentReport>[] => {
  const {
    hiddenHeaderSeparatorRoot,
    onConfirmReceiptClick,
    onUnexpectedFindingsClick,
    onViewClick,
  } = params;

  const { translations } = useTranslations();

  const {
    headerName,
    headerStatus,
    btnDownload,
    btnUnexpectedFindings,
    btnConfirmUnexpectedFindings,
    btnView,
    statusSent,
    statusUnsent,
    statusError,
    statusRequiredReview,
    statusInReview,
    tooltipUnexpectedFindings,
    tooltipReceiptConfirmed,
  } = translations;

  const columnOptions = useColumnOptions({
    translations: {
      btnDownload,
      btnUnexpectedFindings,
      btnConfirmUnexpectedFindings,
      btnView,
    },
    headerClassName: hiddenHeaderSeparatorRoot,
    onConfirmReceiptClick,
    onUnexpectedFindingsClick,
    onViewClick,
  });

  const columns = useMemo(() => {
    return [
      getColumnAlert({
        translations: { tooltipUnexpectedFindings, tooltipReceiptConfirmed },
        headerClassName: hiddenHeaderSeparatorRoot,
      }),
      getColumnName({ translations: { headerName } }),
      getColumnStatus({
        translations: {
          headerStatus,
          statusSent,
          statusUnsent,
          statusError,
          statusRequiredReview,
          statusInReview,
        },
        headerClassName: hiddenHeaderSeparatorRoot,
      }),
      columnOptions,
    ];
  }, [
    tooltipUnexpectedFindings,
    tooltipReceiptConfirmed,
    hiddenHeaderSeparatorRoot,
    headerName,
    headerStatus,
    statusSent,
    statusUnsent,
    statusError,
    statusRequiredReview,
    statusInReview,
    columnOptions,
  ]);

  return columns;
};

export default useColumns;
